import { useTranslation } from "react-i18next";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui";

interface ReferenceActivationDialogProps {
  open: boolean;
  onOpenChange: (next: boolean) => void;
  deactivate: boolean;
  processing: boolean;
  onConfirm: () => void;
}

export function ReferenceActivationDialog({
  open,
  onOpenChange,
  deactivate,
  processing,
  onConfirm,
}: ReferenceActivationDialogProps) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="capitalize">
            {deactivate ? t("ui.deactivate") : t("ui.activate")}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {deactivate
              ? t("feature.references.detail.confirmDeactivate")
              : t("feature.references.detail.confirmActivate")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={processing}>{t("ui.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={processing}>
            {t("ui.ok")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
